module.exports = __webpack_public_path__ + "static/media/messanger.c4ffe6a0.svg";